var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBillingDetail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2052_40817)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 48,
    height: 48,
    rx: 10,
    fill: "#E8EEFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.0168 14.75C31.3176 14.7517 30.75 15.3201 30.75 16.01V22.25H33.42C34.0494 22.25 34.4903 22.054 34.7722 21.7722C35.054 21.4903 35.25 21.0494 35.25 20.42V18C35.25 17.1097 34.8867 16.2965 34.2979 15.6985C33.7158 15.1174 32.9052 14.7591 32.0168 14.75ZM29.25 16.01C29.25 14.4809 30.5006 13.25 32.02 13.25H32.0269L32.0269 13.25C33.3161 13.2619 34.5033 13.7826 35.3603 14.6397L35.364 14.6433L35.364 14.6433C36.214 15.5052 36.75 16.6913 36.75 18V20.42C36.75 21.3706 36.446 22.2197 35.8328 22.8328C35.2197 23.446 34.3706 23.75 33.42 23.75H30C29.5858 23.75 29.25 23.4142 29.25 23V16.01Z",
    fill: "#2948A7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3074 14.6811C17.1121 13.7491 18.3465 13.25 20 13.25H32C32.4142 13.25 32.75 13.5858 32.75 14C32.75 14.4142 32.4142 14.75 32 14.75C31.3142 14.75 30.75 15.3142 30.75 16V33C30.75 34.4418 29.1035 35.2564 27.9529 34.4022L27.9506 34.4004L26.2327 33.1145C26.1465 33.0482 26.0086 33.0521 25.9203 33.1403L24.2403 34.8203C23.5574 35.5032 22.4426 35.5032 21.7597 34.8203L21.7581 34.8187L20.0997 33.1503C20.0995 33.1501 20.0999 33.1505 20.0997 33.1503C20.0004 33.0516 19.8576 33.0468 19.76 33.12L18.0529 34.3978C18.0522 34.3983 18.0515 34.3989 18.0508 34.3994C16.8927 35.2743 15.25 34.4434 15.25 33V18C15.25 16.7971 15.5203 15.5924 16.3074 14.6811ZM29.5517 14.75H20C18.6535 14.75 17.8879 15.1459 17.4426 15.6614C16.9797 16.1976 16.75 16.9929 16.75 18V33C16.75 33.2157 16.9854 33.3247 17.1471 33.2022L17.1506 33.1996L18.86 31.92C19.5622 31.3934 20.5396 31.4689 21.1603 32.0897L21.1619 32.0913L22.8203 33.7597C22.8202 33.7595 22.8205 33.7598 22.8203 33.7597C22.9175 33.8563 23.0827 33.8566 23.1797 33.7597L24.8597 32.0797C25.4701 31.4693 26.4493 31.3922 27.1428 31.9221L28.8471 33.1978C28.8473 33.198 28.8476 33.1982 28.8479 33.1984C29.0173 33.3232 29.25 33.1979 29.25 33V16C29.25 15.5504 29.3589 15.1254 29.5517 14.75Z",
    fill: "#2948A7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.25 25.01C22.25 24.5958 22.5858 24.26 23 24.26H26C26.4142 24.26 26.75 24.5958 26.75 25.01C26.75 25.4242 26.4142 25.76 26 25.76H23C22.5858 25.76 22.25 25.4242 22.25 25.01Z",
    fill: "#2948A7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.25 21.01C22.25 20.5958 22.5858 20.26 23 20.26H26C26.4142 20.26 26.75 20.5958 26.75 21.01C26.75 21.4242 26.4142 21.76 26 21.76H23C22.5858 21.76 22.25 21.4242 22.25 21.01Z",
    fill: "#2948A7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9961 25C18.9961 24.4477 19.4438 24 19.9961 24H20.0051C20.5574 24 21.0051 24.4477 21.0051 25C21.0051 25.5523 20.5574 26 20.0051 26H19.9961C19.4438 26 18.9961 25.5523 18.9961 25Z",
    fill: "#2948A7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9961 21C18.9961 20.4477 19.4438 20 19.9961 20H20.0051C20.5574 20 21.0051 20.4477 21.0051 21C21.0051 21.5523 20.5574 22 20.0051 22H19.9961C19.4438 22 18.9961 21.5523 18.9961 21Z",
    fill: "#2948A7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2052_40817",
    x: 0,
    y: 0,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2052_40817"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2052_40817",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillingDetail);
export default __webpack_public_path__ + "static/media/billingDetail.e7a2595bd1483c1d6eb8fd44ea76a314.svg";
export { ForwardRef as ReactComponent };